import Link from 'next/link';
import Image from 'next/image';
import { ReactNode } from 'react';
import { useModalContext } from '@/presentation/context/modal';
import { emDash } from '@/presentation/utils/text';
import { useTranslations } from 'use-intl';
import { useAlertContext } from '@/presentation/context/alert';

const Topbar = ({
  withNavigation,
  connectButton,
  currencySelect,
  networkSelect,
  bountyButton,
  themeToggle,
  overlayMenu,
  search,
  isTestnet,
}: {
  isTestnet: boolean;
  withNavigation?: boolean;
  connectButton?: ReactNode;
  bountyButton?: ReactNode;
  currencySelect?: ReactNode;
  networkSelect?: ReactNode;
  themeToggle?: ReactNode;
  overlayMenu?: ReactNode;
  search?: ReactNode;
}) => {
  const t = useTranslations('Topbar');
  const { showFaucetModal } = useModalContext();
  const { alertText } = useAlertContext();

  return (
    <>
      {alertText && (
        <div className="bg-red-600 h-8 text-center text-white text-sm flex items-center justify-center">
          {alertText}
        </div>
      )}
      <div className="bg-gradient-pink-orange h-6 text-center text-white text-sm flex items-center justify-center truncate">
        {t('Legacy.text')}
        <span className="mx-2">{emDash}</span>
        {isTestnet ? (
          <button
            onClick={() => showFaucetModal()}
            type="button"
            className="underline hover:no-underline font-medium"
          >
            {t('faucet.tokens')}
          </button>
        ) : (
          <Link
            href={'https://v2.nftx.io'}
            target="_blank"
            rel="nofollow noreferrer"
            className="underline hover:no-underline font-medium"
          >
            {t('Legacy.viewV2')}
          </Link>
        )}
      </div>
      <div className="bg-gray-50 px-4 py-3 md:py-4 flex items-center h-16 md:h-20 relative">
        <Link
          href={'/'}
          className="font-bold text-transparent bg-clip-text bg-gradient-to-br from-pink-500 to-pink-800 text-2xl md:ml-2"
        >
          <Image
            src="/images/NFTX_logotype_on_white.svg"
            alt="NFTX"
            height={23}
            width={100}
            className="hidden dark:hidden md:block"
          />
          <Image
            src="/images/NFTX_logo_on_white.svg"
            alt="NFTX"
            height={32}
            width={32}
            className="dark:hidden block md:hidden"
          />
          <Image
            src="/images/NFTX_logotype_on_black.svg"
            alt="NFTX"
            height={23}
            width={100}
            className="hidden dark:md:block"
          />
          <Image
            src="/images/NFTX_logo_on_black.svg"
            alt="NFTX"
            height={32}
            width={32}
            className="hidden dark:block dark:md:hidden"
          />
        </Link>
        <div className="mx-4 md:mx-8 rounded-md flex-1 max-w-xs group">
          {search}
        </div>
        {withNavigation && (
          <nav>
            <ul className="flex items-center space-x-8 capitalize">
              {['dashboard', 'swap', 'tokens', 'NFTs', 'pools'].map((page) => (
                <li key={page}>
                  <Link
                    href={`/${page}`}
                    className="text-gray-500 hover:text-gray-800 font-semibold"
                  >
                    {page}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        )}
        <aside className="ml-auto pl-8 space-x-4 hidden md:flex md:items-center">
          {bountyButton}
          {themeToggle}
          {currencySelect}
          {networkSelect}
          {connectButton}
        </aside>
        <aside className="ml-auto flex md:hidden">{overlayMenu}</aside>
      </div>
    </>
  );
};

export default Topbar;
